import { render, staticRenderFns } from "./TraxAccountGroupCrud.vue?vue&type=template&id=333ac6b2"
import script from "./TraxAccountGroupCrud.vue?vue&type=script&lang=js"
export * from "./TraxAccountGroupCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports